var styles = {"promoBadge":"index-module_promoBadge__I03pg"};

export { styles as default };
//# sourceMappingURL=index.module.css.js.map
